import React from "react";
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
} from "@mui/material";
import { fonts, headingFonts } from "../../../Styles/Styles";

const steps = [
  {
    label: "Find Your Service Provider",
    description:
      "Choose a Service and select from a list of verified and client-reviewed professionals for the job.",
  },
  {
    label: "Schedule at Your Convenience",
    description:
      "Choose a date and time that works best for you, and leave the rest to your trusted provider.",
  },
  {
    label: "Pay the Service Provider",
    description:
      "Pay the Service Provider directly after the completion of your task.",
  },
  {
    label: "Rate the Service",
    description: "Share your feedback with us.",
  },
];

const HowItWorks = () => {
  return (
    <Box
      sx={{
        mt: 2,
        mb: 3,
        flex: 1,
        pt: 2,
        pb: 2,
        pl: 3,
        pr: 3,
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ ...headingFonts }}>
        How It Works
      </Typography>
      <Stepper orientation="vertical">
        {steps.map((step, index) => (
          <Step key={index} active={true}>
            <StepLabel>
              <Typography variant="subtitle1" sx={{ ...headingFonts }}>
                {step.label}
              </Typography>
            </StepLabel>
            <StepContent>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ ...fonts }}
              >
                {step.description}
              </Typography>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default HowItWorks;
